export interface ICheekSwabRequestValidation {
    firstName: boolean,
    lastName: boolean,
    address1: boolean,
    address2: boolean,
    city: boolean,
    state: boolean,
    postalCode: boolean,
    contactPhone: boolean,
    email: boolean,
    dob: boolean
}